import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all tblPartsCategorys
export const getPartsCategory = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/parts-category`);
    return response.data;
  } catch (error) {
    console.error("Error fetching parts-category:", error.response?.data || error);
    throw error;
  }
};

// GET a single tblPartsCategory
export const getPartsCategoryById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/parts-category/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching parts-category:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new tblPartsCategory
export const createPartsCategory = async (tblPartsCategoryData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/parts-category`, tblPartsCategoryData);
    return response.data;
  } catch (error) {
    console.error("Error creating parts-category:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing tblPartsCategory
export const updatePartsCategory = async (id, tblPartsCategoryData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/parts-category/${id}`, tblPartsCategoryData);
    return response.data;
  } catch (error) {
    console.error("Error updating parts-category:", error.response?.data || error);
    throw error;
  }
};

// DELETE a tblPartsCategory
export const deletePartsCategory = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/parts-category/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting parts-category:", error.response?.data || error);
    throw error;
  }
};
